export default __webpack_public_path__ + "static/media/chevron-down.17f2c647.svg";